
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { User } from '@core';

import { TwoFactorAuthQrCodeModalComponent } from '../two-factor-auth-qr-code/two-factor-auth-qr-code-modal.component';

@Component({
    selector: 'toggle-user-two-factor-auth',
    templateUrl: './toggle-user-two-factor-auth.component.html',
    styleUrls: ['./toggle-user-two-factor-auth.component.scss'],
    standalone: true,
    imports: [MatButtonModule, MatIconModule]
})
export class ToggleUserTwoFactorAuthComponent {
  private _user: User | undefined;

  @Input() disableCancel = false;
  @Input({ required: true }) set user(user: User) {
    this._user = user;
  }

  get user(): User {
    return this._user!;
  }

  constructor(private dialog: MatDialog) {}

  protected toggle2Fa() {
    this.dialog.open(TwoFactorAuthQrCodeModalComponent, {
      disableClose: true,
      data: { user: this.user, disableCancel: false },
      width: '80vw',
      height: '100vh',
      maxWidth: '80vw',
      maxHeight: '100vh',
      position: { right: '0' },
      panelClass: 'two-factor-auth-qr-code-modal',
      hasBackdrop: true,
    });
  }
}
